import CommonModal from "views/components/CommonModal";
import styles from "./index.module.less";
import { useState, useRef, useEffect } from "react";
import { Toast } from "react-vant";
import { getUrlParams } from "utils/tools";
import { inviteRgisterV2, sendVerificationCode, visit } from "@/api/register";

const btnImg = require("@/assets/images/new-invite/btn.png");
const topImg = require("@/images/channel-register/top-img.png");
const bottomImg = require("@/images/channel-register/bottom-img.png");
const iconImg = require("@/images/channel-register/icon.png");
const cancelImg = require("@/images/mine/recommend-officer/button_cancel.png");

const PHONE_REGEX = /^\d{11}$/;

export default function ChannelRegister() {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [codeText, setCodeText] = useState("发送验证码");

  const [modalInfo, setModalInfo] = useState({
    show: false,
    title: "",
    content: null,
    appType: 1,
  });

  const countDownRef = useRef(null);

  useEffect(() => {
    const { second_source } = getUrlParams();
    visit(second_source ? { second_source } : {});

    // 组件卸载时清理定时器
    return () => {
      if (countDownRef.current) {
        clearInterval(countDownRef.current);
      }
    };
  }, []);

  const handleSendCode = async () => {
    if (countDownRef.current) return;
    if (!phone) return Toast.info("请输入手机号码");
    if (!PHONE_REGEX.test(phone)) return Toast.info("请输入正确的手机号码");

    const loadingToast = Toast.loading({
      message: "正在发送验证码...",
      forbidClick: true,
      duration: 0,
    });

    try {
      const result = await sendVerificationCode({ phone_number: phone });

      if (result?.status) {
        let time = 60;
        setCodeText(`再次发送(${time}s)`);
        countDownRef.current = setInterval(() => {
          --time;
          if (time > 0) {
            setCodeText(`再次发送(${time}s)`);
          } else {
            clearInterval(countDownRef.current);
            countDownRef.current = null;
            setCodeText("发送验证码");
          }
        }, 1000);
      } else {
        Toast.info(result?.message || "发送失败");
      }
    } finally {
      loadingToast.clear();
    }
  };

  const handleSubmit = async () => {
    if (!phone) return Toast.info("请输入手机号");
    if (!PHONE_REGEX.test(phone)) return Toast.info("请输入正确的手机号码");
    if (!code) return Toast.info("请输入验证码");
    if (!agreed) return Toast.info("请勾选同意协议");

    const { source, second_source } = getUrlParams();
    const res = await inviteRgisterV2({
      phone_number: phone,
      verification_code: code,
      source,
      second_source,
    });

    if (res?.code === 200) {
      const { status, title, validity, msg, app_type } = res.data || {};

        setModalInfo({
          show: true,
          title: status ? "领取成功" : "领取失败",
          appType: app_type,
          content: status ? (
            <>
              <div>成功领取</div>
              <div>{title}</div>
              <div>课程有效期：{validity}</div>
            </>
          ) : (
            <div>{msg}</div>
          ),
        });
    } else {
      Toast.info(res?.message || "未知错误");
    }
  };

  const closeModal = () => setModalInfo((prev) => ({ ...prev, show: false }));

  const handleDownload = () => {
    const downloadUrls = {
      1: "https://downloads-apk.myaitalk.vip/",
      2: "https://downloads-reading.myaitalk.vip/",
    };

    const url = downloadUrls[modalInfo.appType];
    if (url) {
      window.location.href = url;
    }
    closeModal();
  };

  return (
    <div className={styles["sales-invite-page"]}>
      <CommonModal isOpen={modalInfo.show}>
        <div className={styles["pop-container--lock"]}>
          <div className={styles["lock-wrapper"]}>
            <div className={styles["lock-wrapper-title"]}>
              {modalInfo.title}
            </div>
            <div className={styles["lock-wrapper-text"]}>
              {modalInfo.content}
            </div>
            <div className={styles["lock-confirm"]} onClick={handleDownload}>
              立即下载APP
            </div>
          </div>
          <img
            onClick={closeModal}
            className={styles["lock-close"]}
            src={cancelImg}
            alt="close"
          />
        </div>
      </CommonModal>

      <div className={styles["sales-invite-inner"]}>
        <img className={styles["top-img"]} src={topImg} alt="top-banner" />

        <div className={styles["form-card"]}>
          <div className={styles["form-item"]}>
            <input
              className={styles["form-input"]}
              type="tel"
              placeholder="手机号"
              maxLength={11}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className={`${styles["form-item"]} ${styles["code-row"]}`}>
            <input
              className={`${styles["form-input"]} ${styles["code-input"]}`}
              type="text"
              placeholder="验证码"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <button
              className={`${styles["send-code-btn"]} ${
                countDownRef.current ? styles.disabled : ""
              }`}
              onClick={handleSendCode}
            >
              {codeText}
            </button>
          </div>

          <div className={styles["agreement-row"]}>
            <span
              className={`${styles["custom-checkbox"]} ${
                agreed ? styles.checked : ""
              }`}
              onClick={() => setAgreed((v) => !v)}
            >
              {agreed && <span className={styles.checkmark}>✓</span>}
            </span>
            <span className={styles["agreement-text"]}>
              同意
              <a
                className={styles.link}
                href="https://cdn06.myaitalk.vip/privacy/en/v2/reading-course-service-agreement.html"
                target="_blank"
                rel="noreferrer"
              >
                《课程服务协议》
              </a>
              与
              <a
                className={styles.link}
                href="https://cdn03.myaitalk.vip/utalkrc/privacy/en/pocketlinghang-reading-privacy-policy-v4.html"
                target="_blank"
                rel="noreferrer"
              >
                《隐私政策》
              </a>
            </span>
          </div>

          <div className={styles["submit-row"]}>
            <button className={styles["submit-btn"]} onClick={handleSubmit}>
              <img src={btnImg} alt="立即体验" />
            </button>
          </div>

          <div className={styles["footer-tip"]}>
            <img
              className={styles["footer-tip-icon"]}
              src={iconImg}
              alt="icon"
            />
            <span>点击「立即体验」0元立享5节北美AI外教课</span>
          </div>
        </div>

        <img
          className={styles["bottom-img"]}
          src={bottomImg}
          alt="bottom-banner"
        />
      </div>
    </div>
  );
}
